/**
 * MenuListContainer
 * --
 */
import React from 'react';
import MenuListPresenter from './MenuListPresenter';

const MenuListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MenuListPresenter />
    </>
  );
};

export default MenuListContainer;
